module.exports = __webpack_public_path__ + "img/iOS_miaoshu.89ec0564.png";